import React, {Component} from 'react';
import { CircleQuestionMark } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import {connect} from 'react-redux';
import * as reduxSelectors from '../../store/application.reducers';
import {
    getCostUnitsRoles,
    sortCostUnitRoles,
    getCostUnitsBranches
} from '../costunits.action';
import {LOADING_STATUS} from "utils/constants.js";
import arrow from "../../../assets/ill-pointing_arrow-top-right.svg";
import businessman from "../../../assets/businessman.png";
import {AssignApproversGridHeader} from "./AssignApproversGridHeader.component";
import {AssignApproversRow} from "./CostUnitsApproversRow.component";
import SearchGroupInput from "../../input/SearchGroupInput.component";
import { Button, ButtonType } from "components/common/Button.component";
import { DropdownSelect } from "components/common/dropdown/DropdownSelect.component";
import { DropdownSelectTypes, DropdownPosition } from "types/gaiaComponents/dropdownButton.types";

class AssignApproverGrid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showLastRow: false,
            isEditing: false,
            filters: {
                approver: '',
                role: '',
                deputy: '',
                branch: '',
                skip: ''
            },
        };
        this.insertNewRow = this.insertNewRow.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.setEditMode = this.setEditMode.bind(this);
        this.onRoleFilterChange = this.onRoleFilterChange.bind(this);
        this.onRoleFilterClear = this.onRoleFilterClear.bind(this);
        this.onApproverFilterChange = this.onApproverFilterChange.bind(this);
        this.onApproverFilterClear = this.onApproverFilterClear.bind(this);
        this.onDeputyFilterSelect = this.onDeputyFilterSelect.bind(this);
        this.onBranchFilterChange = this.onBranchFilterChange.bind(this);
        this.onSkipFilterSelect = this.onSkipFilterSelect.bind(this);
    }

    componentDidMount() {
        this.props.getCostUnitsRoles(this.props.companyId);
        this.props.getCostUnitsBranches(this.props.companyId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.costUnitRoles && prevProps.costUnitRoles && prevProps.costUnitRoles.costUnitId !== this.props.costUnitRoles.costUnitId) {
            this.cancelEdit();
        }
    }

    insertNewRow() {
        this.setState({showLastRow: true, isEditing: true});
        this.props.preventNavigation(true);
    }

    cancelEdit() {
        this.setState({showLastRow: false, isEditing: false});
        this.props.preventNavigation(false);
    }

    setEditMode(isEditing) {
        this.setState({isEditing: isEditing, okEnabled: isEditing});
        this.props.preventNavigation(isEditing);
    }

    onRoleFilterChange(event) {
        this.setState({
            filters: {
                ...this.state.filters,
                role: event.target.value
            }
        })
    }

    onRoleFilterClear(event) {
        this.setState({
            filters: {
                ...this.state.filters,
                role: ''
            }
        })
    }

    onApproverFilterChange(event) {
        this.setState({
            filters: {
                ...this.state.filters,
                approver: event.target.value
            }
        })
    }

    onApproverFilterClear(event) {
        this.setState({
            filters: {
                ...this.state.filters,
                approver: ''
            }
        })
    }

    onDeputyFilterSelect(property) {
        this.setState({
            filters: {
                ...this.state.filters,
                deputy: property ? property === 'true' : ''
            }
        })
    }

    onBranchFilterChange(property) {
        this.setState({
            filters: {
                ...this.state.filters,
                branch: property
            }
        })
    }

    onSkipFilterSelect(property) {
        this.setState({
            filters: {
                ...this.state.filters,
                skip: property ? property === 'true' : ''
            }
        })
    }

    render() {
        let costUnitCombinations = this.props.costUnitRoles && this.props.costUnitRoles.rows.length > 0 ?
            this.props.costUnitRoles.rows
                //Filters
                .filter((row) => {
                    // Filter by role
                    let matches = true;
                    if (this.state.filters.role) {
                        matches = row.roleName? row.roleName.toLowerCase().includes(this.state.filters.role.toLowerCase()) : false;
                    }
                    return matches
                })
                .filter((row) => {
                    // Filter by approver
                    let matches = true;
                    if (this.state.filters.approver) {
                        matches = row.userNameAndEmail ? row.userNameAndEmail.toLowerCase().includes(this.state.filters.approver.toLowerCase()) : false;
                    }
                    return matches
                })
                .filter((row) => {
                    // Filter by branch
                    let matches = true;
                    if (this.state.filters.branch !== '') {
                        matches = row.branchId === this.state.filters.branch;
                    }
                    return matches
                })
                .filter((row) => {
                    // Filter by deputy
                    let matches = true;
                    if (this.state.filters.deputy !== '') {
                        matches = row.deputy === this.state.filters.deputy;
                    }
                    return matches
                })
                .filter((row) => {
                    // Filter by skip
                    let matches = true;
                    if (this.state.filters.skip !== '') {
                        matches = row.skip === this.state.filters.skip;
                    }
                    return matches
                })
                .map((costUnit, index) => {
                    return (<AssignApproversRow
                        key={`${costUnit.idUser}-${costUnit.role}-${costUnit.branchId}-${index}`}
                        translate={this.props.translate}
                        costUnit={{ ...costUnit}}
                        nodeId={this.props.costUnitRoles.costUnitId}
                        nodeLevel={this.props.costUnitRoles.costUnitLevel}
                        deleteCostUnitRole={this.props.deleteCostUnitRole}
                        costUnitTypes={this.props.costUnitTypes}
                        isEditing={this.state.isEditing}
                        setEditMode={this.setEditMode}
                        sort={this.props.sort}
                        allowActions={this.props.allowActions}
                    />)
                }) :
            (this.state.showLastRow ? "" :
                    (this.props.approversTree?.selectedCostUnit ?
                            <div className="assign-approvers-list-empty">
                                <img className="no-approvers-arrow" src={arrow} alt="Arrow"/>
                                <img src={businessman} alt="Business man"/>
                                <h2>{this.props.translate("costUnitAssignApprovers.noApprovers")}</h2>
                                <p>{this.props.translate("costUnitAssignApprovers.noApproversBody")}</p>
                            </div> :
                            <h2 className="text-center py-3 color-grey">{this.props.translate("costUnitAssignApprovers.noCombinationSelected")}</h2>
                    )
            );

        return (
            <div>
                <h2 className="no-border d-flex align-items-center pt-4">{this.props.translate("costUnitAssignApprovers.header")}
                    <span className="ms-4"
                          data-tooltip-info={`${this.props.translate("costUnitApprovers.headerInfo")}\n\n${this.props.translate("costUnitApprovers.headerInfoSkipCU")}\n\n${this.props.translate("costUnitApprovers.headerInfoSkipCUDetails")}`}>
                        <CircleQuestionMark size={ICON_SIZE.MEDIUM}/>
                    </span>
                    <Button type={ButtonType.PRIMARY}
                            extraClassName={"justify-content-center ms-auto"}
                            onClick={this.insertNewRow}
                            disabled={!this.props.costUnitRoles || this.state.showLastRow || this.state.isEditing || !this.props.allowActions}
                            text={this.props.translate("costUnitAssignApprovers.assignApprover")}
                    />
                </h2>


                <div className="actions-list">
                    <AssignApproversGridHeader translate={this.props.translate}
                                               id={this.props.costUnitRoles ? this.props.costUnitRoles.costUnitId : null}
                                               level={this.props.costUnitRoles ? this.props.costUnitRoles.costUnitLevel : null}
                                               sort={this.props.sort}
                                               onSort={this.props.sortCostUnitRoles}/>

                    {this.props.loadingStatus === LOADING_STATUS.DONE &&
                        <div id="cost-units-assign-approvers-panel" className="main-panel">

                            {/*Filters*/}
                            {this.props.costUnitRoles?.rows?.length > 0 && this.props.approversTree?.selectedCostUnit &&
                                <div className="row py-8 align-items-center gutters-8 px-1">
                                    <div
                                        className={`${this.props.costUnitsBranches.length > 0 ? "col-md-2" : "col-md-3"}`}>
                                            <SearchGroupInput
                                                placeholder={this.props.translate("costUnitAssignApprovers.findRole")}
                                                value={this.state.filters.role}
                                                onInputChange={this.onRoleFilterChange}
                                                onClearInput={this.onRoleFilterClear}
                                                translate={this.props.translate}/>
                                    </div>
                                    <div
                                        className={`${this.props.costUnitsBranches.length > 0 ? "col-md-3" : "col-md-5"}`}>
                                        <SearchGroupInput
                                            placeholder={this.props.translate("costUnitAssignApprovers.findApprover")}
                                            value={this.state.filters.approver}
                                            onInputChange={this.onApproverFilterChange}
                                            onClearInput={this.onApproverFilterClear}
                                            translate={this.props.translate}/>
                                    </div>

                                    {this.props.costUnitsBranches.length > 0 &&
                                        <div className="col-md-3">
                                            <DropdownSelect
                                                id="branch-filter"
                                                type={DropdownSelectTypes.VALUE}
                                                value={this.props.costUnitsBranches.find((branch) => {
                                                    return branch.branchId === this.state.filters.branch
                                                })?.name || this.props.translate("costUnitAssignApprovers.anyBranch")}
                                                position={DropdownPosition.BOTTOM_RIGHT}
                                                extraClasses="w-100"
                                                items={[{
                                                    key: '-1',
                                                    text: this.props.translate("costUnitAssignApprovers.anyBranch"),
                                                    onClick: () => this.onBranchFilterChange('')
                                                }, ...this.props.costUnitsBranches.filter((branch) => {
                                                    return branch.active && !branch.deleted
                                                }).map((branch) => {
                                                    return {
                                                        key: branch.branchId.toString(),
                                                        text: branch.name,
                                                        onClick: () => this.onBranchFilterChange(branch.branchId)
                                                    };
                                                })]}
                                            />
                                        </div>
                                    }
                                    <div className="col-md-1">
                                        <DropdownSelect
                                            id="deputy-filter"
                                            type={DropdownSelectTypes.VALUE}
                                            value={this.props.translate(`costUnitAssignApprovers.${this.state.filters.deputy === '' ? 'all' : this.state.filters.deputy ? 'selected' : 'unselected'}`)}
                                            position={DropdownPosition.BOTTOM_RIGHT}
                                            extraClasses="w-100"
                                            items={[{
                                                key: '-1',
                                                text: this.props.translate("costUnitAssignApprovers.all"),
                                                onClick: () => this.onDeputyFilterSelect('')
                                            }, {
                                                key: '0',
                                                text: this.props.translate("costUnitAssignApprovers.selected"),
                                                onClick: () => this.onDeputyFilterSelect('true')
                                            }, {
                                                key: '1',
                                                text: this.props.translate("costUnitAssignApprovers.unselected"),
                                                onClick: () => this.onDeputyFilterSelect('false')
                                            }]}
                                        />
                                    </div>
                                    <div className="col-md-1">
                                        <DropdownSelect
                                            id="skip-filter"
                                            type={DropdownSelectTypes.VALUE}
                                            value={this.props.translate(`costUnitAssignApprovers.${this.state.filters.skip === '' ? 'all' : this.state.filters.skip ? 'yes' : 'no'}`)}
                                            position={DropdownPosition.BOTTOM_RIGHT}
                                            extraClasses="w-100"
                                            items={[{
                                                key: '-1',
                                                text: this.props.translate("costUnitAssignApprovers.all"),
                                                onClick: () => this.onSkipFilterSelect('')
                                            }, {
                                                key: '0',
                                                text: this.props.translate("costUnitAssignApprovers.yes"),
                                                onClick: () => this.onSkipFilterSelect('true')
                                            }, {
                                                key: '1',
                                                text: this.props.translate("costUnitAssignApprovers.no"),
                                                onClick: () => this.onSkipFilterSelect('false')
                                            }]}
                                        />
                                    </div>
                                </div>}

                            {costUnitCombinations}
                            {this.props.costUnitRoles && this.props.costUnitRoles.rows.length > 0 && costUnitCombinations.length === 0 &&
                                <h2 className="text-center no-border color-grey">
                                    {this.props.translate("costUnitAssignApprovers.noResultsOnFilter")}
                                </h2>
                            }

                            {this.state.showLastRow &&
                                <AssignApproversRow
                                    translate={this.props.translate}
                                    costUnit={{
                                        userNameAndEmail: "",
                                        idUser: "",
                                        roleName: this.props.costUnitTypes.length > 0 ? this.props.costUnitTypes[0].name : "",
                                        role: this.props.costUnitTypes.length > 0 ? this.props.costUnitTypes[0].roleId : "",
                                        branchName: this.state.filters.branch ? this.props.costUnitsBranches.find((branch) => branch.branchId === this.state.filters.branch).name : this.props.translate("costUnitAssignApprovers.anyBranch"),
                                        branchId: this.state.filters.branch ? this.state.filters.branch : 0,
                                        deputy: false,
                                        skip: false,
                                        idCompany: this.props.companyId
                                    }}
                                    lastRow={true}
                                    nodeId={this.props.costUnitRoles.costUnitId}
                                    nodeLevel={this.props.costUnitRoles.costUnitLevel}
                                    cancelEdit={this.cancelEdit}
                                    costUnitTypes={this.props.costUnitTypes}
                                    sort={this.props.sort}
                                    allowActions={this.props.allowActions}
                                />
                            }
                        </div>
                    }
                </div>
            </div>

        );
    }
}

const mapStateToProps = function (store) {
    return {
        costUnitTypes: reduxSelectors.getCostUnitRoleTypes(store),
        loadingStatus: reduxSelectors.getApproversLoadingStatus(store),
        sort: reduxSelectors.getRolesSort(store),
        approversTree: reduxSelectors.getApproversTree(store),
        costUnitsBranches: reduxSelectors.getCostUnitBranches(store),
        companyId: reduxSelectors.getUsersCurrentContextId(store),
    };
};
const AssignApproversGrid = connect(mapStateToProps, {
    getCostUnitsRoles,
    getCostUnitsBranches,
    sortCostUnitRoles
})(AssignApproverGrid);
export default AssignApproversGrid;
